<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增111</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item label="训练营状态">
        <el-select v-model="search.status" placeholder="请选择训练营状态">
          <el-option label="全部" value="" />
          <el-option v-for="item in statusList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item class="search-form-item">
        <el-input v-model="search.search" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="activity-table">
      <tableList ref="multipleTable" size="small" :table-query="search" :query-function="$Api.camp.postCampList" style="width: 100%">
        <el-table-column prop="id" label="训练营ID" />
        <el-table-column prop="name" label="训练营标题" width="auto" />
        <el-table-column prop="status" label="训练营状态">
          <template v-slot="{row}">
            <el-tag :type="camptStatus[row.status].color" :class="camptStatus[row.status].class" size="mini">{{ camptStatus[row.status].value }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="beginTime" label="持续时间" width="200px">
          <template v-slot="{row}">
            {{ row.beginTime && row.endTime && `${formatTime(row.beginTime)} - ${formatTime(row.endTime)}` || '--' }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="380px" label="操作">
          <template v-slot="{row}">
            <el-button size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
            <el-button size="small" type="text" class="link-color" @click="copy(row)">复制</el-button>
            <el-button size="small" type="text" class="link-color" @click="remove(row)">删除</el-button>
            <el-button v-if="row.status === 1" size="small" type="text" class="link-color" @click="postOnlineCamp(row.id)">发布</el-button>
            <el-button v-if="[0,4].includes(row.status)" size="small" type="text" class="link-color" @click="postOfflineCamp(row.id)">下架</el-button>
            <el-button v-if="[0,2,3,4].includes(row.status)" size="small" type="text" class="link-color" @click="exportUsers(row.id)">下载用户名单</el-button>
            <el-button v-if="[0,4].includes(row.status)" size="small" type="text" class="link-color" @click="showUpDialog(row.id)">上传用户名单</el-button>
            <el-button v-if="[0,4].includes(row.status)" size="small" type="text" class="link-color" @click="open(row.id)">开营</el-button>
            <el-button v-if="row.status !== 1" size="small" type="text" class="link-color" @click="downExportList(row.id)">打卡记录</el-button>
          </template>
        </el-table-column>
      </tableList>
      <el-dialog v-if="showUsersDialog" :visible.sync="showUsersDialog" custom-class="user-wrapper" title="上传用户名单">
        <div class="top">
          <p>下载导入模版，根据模板完善内容</p>
          <el-button style="height: 34px; display: flex; align-items: center;" @click="downTemplate">
            <svg-icon icon-class="file1" />下载文件模板
          </el-button>
        </div>
        <div class="middle">
          <p>上传完善好的表格，仅支持上传*.xls、*.xlsx格式</p>
          <el-upload class="upload-box" drag action="" :show-file-list="false" :on-change="handlePushUploader" :auto-upload="false">
            <div>
              <div style="height:50px;">
                <svg-icon icon-class="xls" style="width: 50px; height: 50px;" />
              </div>
              <el-button v-if="!campUsers" size="small">选择文件</el-button>
              <template v-else>
                <div class="file">{{ campUsers.name }}</div>
                <el-button size="small">重新选择</el-button>
              </template>
            </div>
          </el-upload>
        </div>
        <div class="flex btns">
          <el-button type="info" @click="handleCloseImport">取消</el-button>
          <el-button type="primary" @click="uploadSubmit">保存</el-button>
        </div>
      </el-dialog>
      <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSuccess" />
    </div>
  </div>
</template>
<script>
import tableList from '@/components/TableList';
import Dialog from '@/components/Dialog';
import { getFileType } from '@/common/js/util';
import moment from 'moment';
import { campClockExportList } from '@/api/camp';
export default {
  components: { tableList, Dialog },
  data() {
    const statusList = [
      { id: 0, value: '已发布' },
      { id: 1, value: '草稿' },
      { id: 2, value: '进行中' },
      { id: 3, value: '已结束' },
      { id: 4, value: '报名截止' },
    ];
    const camptStatus = {
      0: { value: '已发布', color: 'success' },
      1: { value: '草稿', color: 'warning' },
      2: { value: '进行中', color: 'success', class: 'purple-tag' },
      3: { value: '已结束', color: 'warning', class: "gray-tag" },
      4: { value: '报名截止', color: 'warning', class: "gray-tag" },
    };
    return {
      statusList,
      camptStatus,
      contentType: [],
      search: {
        status: '',
        search: '',
      },
      formDialogShow: false,
      showUsersDialog: false, // 用户名单弹窗
      currentID: -1,
      information: {},
      campUsers: null, // 用户名单excel
    };
  },
  methods: {
    // 保存课程
    uploadSubmit() {
      if (!this.campUsers) {
        this.$message.warning('请先选择文件');
        return;
      }
      const formData = new FormData();
      const param = { campId: this.currentID };
      formData.append('file', this.campUsers);
      formData.append('trainingCampUploadDTO', new Blob([JSON.stringify(param)], { type: 'application/json' }));
      this.$Api.camp.postEnrollmentListUp(formData).then(res => {
        this.$message.success('导入成功');
        this.$refs['multipleTable'].handleCurrentChange(1);
        this.handleCloseImport();
      });
    },
    handlePushUploader(file) {
      if (getFileType(file.raw.name) !== 'excel') {
        this.$message.error('导入失败，请选择Excel文件');
        return;
      }
      this.campUsers = file.raw;
    },
    handleCloseImport() {
      this.campUsers = null;
      this.showUsersDialog = false;
    },
    showUpDialog(id) {
      this.currentID = id;
      this.showUsersDialog = true;
    },
    // 下载报名名单文件模板
    downTemplate() {
      const fileUrl = 'https://uadev-1257321318.cos.ap-beijing.myqcloud.com/static/excel/the_registration_list.xlsx';
      window.open(fileUrl);
    },
    downExportList(id) {
      campClockExportList(id).then(res => {
        if (res) {
          this.$message.success('下载成功');
        }
      });
    },
    // 导出报名名单
    exportUsers(id) {
      this.$Api.camp.getEnrollmentListDown(id)
        .then((res) => {
          if (!res) {
            this.$message.error('该训练营暂无报名人员');
          } else {
            this.$message.success('导出成功');
          }
        });
    },
    formatTime(val) {
      if (val) return moment(val).format('YYYY/MM/DD');
      return '';
    },
    add() {
      this.$router.push({ path: '/online_activity/camp/add' });
    },
    edit(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'edit',
        icon: 'warn',
        subTitle: `是否确认编辑训练营ID为“${row.id}”的数据项？`,
      };
    },
    copy(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'copy',
        icon: 'success',
        subTitle: `复制成功！是否进入新增页面？`,
      };
    },
    remove(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: '删除后小程序用户将无法查看该训练营，请确认是否删除',
      };
    },
    submitSuccess(operation) {
      if (operation === 'delete') {
        this.$Api.camp.getCampDelete(this.currentID).then(() => {
          this.formDialogShow = false;
          this.$message.success('删除成功');
          this.$refs['multipleTable'].getTableList();
        }).catch(error => {
          this.formDialogShow = true;
          this.information = {
            operation: 'error',
            icon: 'error',
            subTitle: `${error.errorMessage}`,
          };
        });
      } else if (operation === 'copy') {
        this.$router.push({ path: '/online_activity/camp/add', query: { copyid: this.currentID } });
      } else if (operation === 'edit') {
        this.$router.push({ path: '/online_activity/camp/edit', query: { id: this.currentID } });
      }
    },
    searchSubmit() {
      this.$refs['multipleTable'].searchAndReset();
    },
    reset() {
      this.search = this.$options.data.call(this).search;
      this.$nextTick(() => {
        this.$refs['multipleTable'].searchAndReset();
      });
    },
    // 开营
    open(id) {
      this.$Api.camp.getCampOpen(id).then(() => {
        this.$message.success('开营成功');
        this.searchSubmit();
      });
    },

    // 上架训练营
    postOnlineCamp(id) {
      this.$Api.camp.getCampPublish(id).then(() => {
        this.$message.success('上架成功');
        this.searchSubmit();
      });
    },
    // 下架训练营
    postOfflineCamp(id) {
      this.$Api.camp.getCampSoldOut(id).then(() => {
        this.$message.success('下架成功');
        this.searchSubmit();
      });
    },

  },
};
</script>
<style lang="less" scoped>
.purple-tag {
  background: rgba(114, 46, 209, 0.1);
  border: 1px solid #722ed1;
  color: #722ed1;
}
.gray-tag {
  background: rgba(73, 73, 73, 0.1);
  border: 1px solid #9b9b9b;
  color: #9b9b9b;
}
/deep/.el-dialog__wrapper {
  .user-wrapper {
    width: 538px;
    .el-dialog__header {
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 30px;
      .top {
        height: 114px;
        margin-bottom: 20px;
        padding: 20px 30px;
        box-sizing: border-box;
        background: #f7f7f7;
        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        p {
          margin-bottom: 20px;
        }
      }
      .middle {
        height: 236px;
        padding: 20px 30px;
        box-sizing: border-box;
        background: #f7f7f7;
        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        margin-bottom: 20px;
        p {
          margin-bottom: 20px;
        }
        .upload-box {
          width: 100%;
          height: 156px;
          .el-upload.el-upload--text {
            width: 100%;
            height: 100%;
            .el-upload-dragger {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #bbbbbb;
              border-radius: 4px;
              .file {
                line-height: 20px;
                margin-top: 5.68px;
              }
              .el-button {
                margin-top: 10px;
              }
              :hover {
                border-color: #1c1c1c;
              }
            }
          }
        }
      }
      .btns {
        justify-content: center;
        margin-top: 30px;
        .el-button {
          width: 120px;
          height: 50px;
        }
        .el-button + .el-button {
          margin-left: 30px;
        }
      }
    }
  }
}
</style>
